
<div class="Section Partners">
    <div class="SectionHeader">
        <span class="PreTitle">Starke Partner an Ihrer Seite</span>
        <h2 class="MainTitle">Unser Netzwerk</h2>
        <p class="SectionDescription">
            Wir arbeiten mit den führenden Anbietern der Branche zusammen, um Ihnen die beste
            Lösung zu bieten.
        </p>
    </div>

    <div class="PartnerCategories">
        <!-- Taxameter Partners -->
        <div class="PartnerCategory">
            <div class="CategoryHeader">
                <h3>Taxameter Partner</h3>
                <span class="CategoryDescription">Zertifizierte Taxameter-Hersteller</span>
            </div>

            <div class="TaxameterGrid">
                <Card
                    class="TaxameterCard"
                    v-for="(partner, index) in taxameterPartners"
                    :key="index"
                >
                    <div class="PartnerImageContainer">
                        <img
                            v-if="partner.logo === 'hale.png'"
                            :src="`/partners/${partner.logo}`"
                            :alt="`${partner.name} - TaxiFusion Partner für TSE-konforme Taxameter`"
                            width="120"
                            height="55"
                            loading="lazy"
                        />
                        <img
                            v-else-if="partner.logo === 'semitron.png'"
                            :src="`/partners/${partner.logo}`"
                            :alt="`${partner.name} - TaxiFusion Partner für TSE-konforme Taxameter`"
                            width="120"
                            height="68"
                            loading="lazy"
                        />
                        <img
                            v-else-if="partner.logo === 'digitax.png'"
                            :src="`/partners/${partner.logo}`"
                            :alt="`${partner.name} - TaxiFusion Partner für TSE-konforme Taxameter`"
                            width="120"
                            height="34"
                            loading="lazy"
                        />
                        <img
                            v-else
                            :src="`/partners/${partner.logo}`"
                            :alt="`${partner.name} - TaxiFusion Partner für TSE-konforme Taxameter`"
                            width="120"
                            height="80"
                            loading="lazy"
                        />
                    </div>
                    <div class="TaxameterInfo">
                        <h4>{{ partner.name }}</h4>
                        <span class="TaxameterDescription">{{ partner.description }}</span>
                    </div>
                </Card>
            </div>
        </div>

        <!-- Umrüster Partners -->
        <div class="PartnerCategory">
            <div class="CategoryHeader">
                <h3>Umrüster Partner</h3>
            </div>

            <div class="EinbauerCTABanner">
                <div class="BannerMapPreview">
                    <div class="MapContainer">
                        <l-map
                            v-if="showMap"
                            :zoom="zoom"
                            :center="mapCenter"
                            :minZoom="5"
                            :maxZoom="8"
                            :options="{ zoomControl: false, attributionControl: false }"
                            style="height: 100%; width: 100%"
                        >
                            <l-tile-layer :url="url" :attribution="attribution" />
                            <l-marker
                                v-for="(location, index) in allEinbauerLocations"
                                :key="index"
                                :lat-lng="[location.lat, location.lng]"
                                :icon="getMarkerIcon(location)"
                            />
                        </l-map>
                    </div>
                    <div class="MapOverlay">
                        <div class="MapBadge">
                            <i class="ri-map-pin-line"></i>
                            <span>{{ einbauerCountDisplay }}+ Einbauer verfügbar</span>
                        </div>
                    </div>
                </div>
                <div class="BannerContent">
                    <div class="BannerHeader">
                        <h4>Deutschlandweites Servicenetz</h4>
                        <p>
                            Finden Sie einen zertifizierten Umrüster oder Servicepartner in
                            Ihrer Nähe.
                        </p>
                    </div>
                    <div class="BannerActions">
                        <router-link to="/einbauer" class="PrimaryCTA">
                            <SiteButton>
                                Einbauer Finden
                                <i class="ri-arrow-right-line"></i>
                            </SiteButton>
                        </router-link>
                        <div class="SecondaryInfo">
                            <p>
                                <i class="ri-question-line"></i>
                                Ist Ihre Werkstatt noch nicht als Partner registriert?
                            </p>
                            <p class="ContactInfo">
                                Kein Problem, die Freischaltung dauert nur wenige Werktage.
                                <a href="tel:+4930959982020">Rufen Sie uns an: 030 959982020</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="CategoryHeader">
            <h3>Premium Partner</h3>
        </div>
        <!-- Premium Partner Banner -->
        <div class="PremiumPartnerBanner">
            <div class="BannerContent">
                <div class="BannerHeader">
                    <h4><strong>myPOS - Premium-Partner für Ihre Taxiflotte</strong></h4>
                    <p>
                        Profitieren Sie von exklusiven Konditionen bei myPOS. Als TaxiFusion
                        Partner erhalten Sie das myPOS Go 2 Terminal
                        <span v-if="showPromotion" class="PriceBadge Free">
                            <i class="ri-gift-line"></i>
                            Wert: 9€ GRATIS
                        </span>
                        <span v-else class="PriceText"> für nur <u>9€ bei TaxiFusion</u> </span
                        >.
                    </p>
                </div>
                <div class="BannerActions">
                    <SiteButton
                        variant="success"
                        class="PremiumCTA"
                        @onClick="goToExclusiveOffers"
                    >
                        Alle Angebote ansehen
                        <i class="ri-arrow-right-line"></i>
                    </SiteButton>
                </div>
            </div>
            <div class="BannerVisual">
                <div class="VisualContainer">
                    <div class="PartnerImage">
                        <img src="/partners/mypos-lifestyle.jpeg" alt="myPOS Lifestyle" />
                    </div>
                    <div class="VisualBadge">
                        <i class="ri-award-line"></i>
                        <span>Exklusive Partner</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
